import Axios from "../utils/tms-axios/tms-axios";

export const EmployeePassServices = {
  createEmployeePass: async (body) => {
    const resp = await Axios.post(`em/employee-pass`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  getEmployeePasses: async () => {
    const resp = await Axios.get(`em/employee-pass`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  updateEmployeePass: async (id, body) => {
    const resp = await Axios.patch(`em/employee-pass/${id}`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  deleteEmployeePass: async (id) => {
    const resp = await Axios.delete(`em/employee-pass/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  scanEmployeePass: async (id) => {
    const resp = await Axios.get(`em/employee-scan/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  createEmplyeeCounter: async (body) => {
    const resp = await Axios.post(`em/employee-counter/create`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  getEmployeePassCounters: async () => {
    const resp = await Axios.get(`em/employee-counter/all`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  deleteEmployeePassCounter: async (id) => {
    const resp = await Axios.delete(`em/employee-counter/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  //referrals
  createEmployeePassReferral: async (body) => {
    const resp = await Axios.post(`em/employee-pass/referrals`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  getEmployeeReferralById: async (id) => {
    const resp = await Axios.get(`em/employee-pass/referrals/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  updateEmployeeRefferal: async (id, body) => {
    const resp = await Axios.patch(`em/employee-pass/referrals/${id}`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  deleteEmployeeReferral: async (id) => {
    const resp = await Axios.delete(`em/employee-pass/referrals/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
  getEmployeeLogs: async (fromDate, toDate, page, limit, counterId) => {
    let url = `em/employee-pass/logs?page=${page}&limit=${limit}&fromDate=${fromDate}&toDate=${toDate}`;
    if (counterId) {
      url = url + `&counterId=${counterId}`;
    }
    const resp = await Axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
};
